import DOMPurify from 'dompurify';

// Shared allowlist for every place we render backend- or user-authored HTML, so the
// trust boundary is defined once instead of per component.
const config = {
    ALLOWED_TAGS: [
        'p',
        'br',
        'strong',
        'em',
        'u',
        'i',
        'b',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'ul',
        'ol',
        'li',
        'a',
        'img',
        'div',
        'span',
    ],
    // `style` and `class` are deliberately excluded. DOMPurify treats `style` as a URI-safe
    // attribute and passes its value through without parsing the CSS, so an inline
    // `background: url(https://attacker/beacon)` would survive sanitizing and leak a request on
    // render, and `position: fixed` would let authored content overlay the app. Styling belongs
    // to the component that renders the sanitized HTML.
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'width', 'height'],
    ALLOWED_SCHEMES: ['http', 'https', 'mailto'],
    ALLOW_DATA_ATTR: false,
};

export const sanitizeHtml = (html: string): string => DOMPurify.sanitize(html || '', config);
